import { useQuery } from "@tanstack/react-query";
import { ApiGetUserCexPnlSummary } from "@/api";
import type { GetUserCexPnlSummaryResponse } from "@/api/types";

/**
 * 获取当前用户 CEX 盈亏汇总（今日 + 累计）
 * 对应接口：`/game/cex/GetUserCexPnlSummary`
 */
export function useGetUserCexPnlSummary() {
  return useQuery({
    queryKey: ["userCexPnlSummary"],
    queryFn: async (): Promise<GetUserCexPnlSummaryResponse> => {
      const res = await ApiGetUserCexPnlSummary({});
      console.log("useGetUserCexPnlSummary", res.data);
      return res.data;
    },
  });
}
